function SiteMaintenance(){
   return (
   <div style={{display:'flex',justifyContent:'center',alignItems:'center', minHeight:'400px'}}>
    <p style={{fontSize:'40px',textAlign:'center'}}>Sito momentaneamente chiuso per manutenzione</p>
    </div>
  )
}

export default SiteMaintenance;